import AccountNotifyCard from './AccountNotifyCard';

export default AccountNotifyCard;
